import { formatClock, formatDay, formatDuration } from "@viamissa/time";
import type { ServiceKind } from "@viamissa/masstimes";

export { formatDuration };

/** "9:30 AM", with the zone added when it differs from the trip's home zone. */
export function clock(instant: number, timeZone: string, homeZone: string): string {
  return formatClock(instant, timeZone, { zoneName: timeZone !== homeZone });
}

/** "Sun, Oct 18 · 9:30 AM". */
export function dayClock(instant: number, timeZone: string, homeZone: string): string {
  return `${formatDay(instant, timeZone)} · ${clock(instant, timeZone, homeZone)}`;
}

export const KIND_LABEL: Record<ServiceKind, string> = {
  sunday: "Sunday Mass",
  vigil: "Sunday vigil Mass",
  weekday: "Weekday Mass",
  holyday: "Holy day Mass",
  "holyday-vigil": "Holy day vigil Mass",
  confession: "Confession",
  adoration: "Adoration",
  devotion: "Devotion",
  other: "Other",
};

export const WEEKDAY_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const KM_PER_MILE = 1.609344;
export const miles = (km: number) => km / KM_PER_MILE;

export function distance(km: number): string {
  const mi = miles(km);
  return mi < 10 ? `${mi.toFixed(1)} mi` : `${Math.round(mi)} mi`;
}

/** "Sunday, October 18" for a YYYY-MM-DD key. */
export function longDate(key: string): string {
  const [year, month, day] = key.split("-").map(Number) as [number, number, number];
  return new Intl.DateTimeFormat("en-US", { timeZone: "UTC", weekday: "long", month: "long", day: "numeric" }).format(
    new Date(Date.UTC(year, month - 1, day)),
  );
}
